import React, { Fragment, useEffect, useState } from "react";
import { getMasterVerificationCodeCall } from "../../../Api/ApiCalls";
import { handleError } from "../../../utils/SharedFunctions";
import {formatDteTime} from "../../../utils/dateUtils";

export default function MasterValidationCode() {
  const [validationCode, setValidationCode] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMasterValidationCode = async () => {
      try {
        setIsLoading(true);
        setError("");
        
        const response = await getMasterVerificationCodeCall();
        console.log(response);
        if (response) {
          setValidationCode(response.code || "");
          
          // Format the date from ISO string to readable format
          if (response.validUntil) {
            const date = new Date(response.validUntil);
            setExpirationDate(formatDteTime(date));
          }
        }
      } catch (error) {
        console.error("Error fetching master validation code:", error);
        setError("Failed to load master validation code");
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMasterValidationCode();
  }, []);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Master Validation Code</h4>
            </div>
            <div className="card-body">
              {isLoading ? (
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
              ) : error ? (
                  <div className="alert alert-danger">
                    <strong>Error:</strong> {error}
                  </div>
              ) : (
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label className="form-label">Validation Code</label>
                        <div className="input-group">
                          <input
                              type="text"
                              className="form-control"
                              value={validationCode}
                              readOnly
                              style={{
                                backgroundColor: '#f8f9fa',
                                fontSize: '1.2em',
                                fontWeight: 'bold',
                                color: '#495057'
                              }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
              )}

              <div className="mt-3">
                <div className="alert alert-info">
                  <strong>Info:</strong> This is the master validation code that can be used for validation purposes..
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}